import { render } from "./Protest.vue?vue&type=template&id=1f75e4af&scoped=true&ts=true"
import script from "./Protest.ts?vue&type=script&lang=ts"
export * from "./Protest.ts?vue&type=script&lang=ts"

import "./Protest.scss?vue&type=style&index=0&id=1f75e4af&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f75e4af"]])

export default __exports__